import { connect } from 'react-redux'
import omit from 'lodash/omit'
import { SHIPMENT_TABS } from 'apps/booking/constants/shipments'
import { filtersUpdate } from 'apps/booking/utils/actions/filters'
import { selectIssueState } from 'apps/booking/utils/actions/issueStates'
import { TIssueState } from 'constants/issueStatus'
import IssueStateSidebar from './IssueStateSidebar'
import { TStatus } from './types'

interface IStateProps {
  ui: {
    selectedTab: {
      status: TStatus
    }
    selectedTabIndex: number
  }
  filters: {
    issueState: TIssueState
    searchParams: Record<string, string>
  }
}

export const connectedContainer = connect(
  (state: IStateProps) => {
    const { filters, ui } = state || {}
    const { selectedTabIndex } = ui || {}
    const { status = [] } = SHIPMENT_TABS[selectedTabIndex] || {}
    const { issueState } = filters || {}

    return {
      status,
      issueState,
      filters: omit(filters.searchParams, ['issueStates', 'issue_states']),
    }
  },
  dispatch => ({
    onClick: (issueState: TIssueState, status: TStatus, selected: boolean) => {
      issueState = selected ? '' : issueState

      dispatch(selectIssueState({ issueState, status }))
      dispatch(filtersUpdate({ issueState, status }))
    },
  })
)(IssueStateSidebar)

export default connectedContainer
